import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class InvocingService {
  url = environment.apiUrl;
  urlInvoice = environment.apiInvoicing;

  constructor(private http: HttpClient) {

  }



  getStationInvoice(): Observable<any> {

    return this.http.get(this.url + 'Invoicing/station')

  }

  apiInvoiceLogin(): Observable<any> {

    let data = {
      usuario: 'B65FFE0CEC61786D5D090268B99A14A807101D847FE4F5FBB4DAA2764B73CD84',
      password: 'NmSQMxZMAZhkVtMxh8un+Q=='
    }

    return this.http.post(this.urlInvoice + 'api/Login', data)

  }

  getListInvoice(date: Date, clientNumber: number, personName: string, magna: boolean, premium: boolean, diesel: boolean, token: string): Observable<any> {

    
    let dateFormatted =  date.toISOString().substring(0,10);

    console.log(dateFormatted)

    return this.http.get(this.url + 'Invoicing/consumptions?toDate=' + dateFormatted + "&clientNumber=" + clientNumber + "&personName=" + personName + "&magna=" + magna + "&premium=" + premium + "&diesel=" + diesel);

  }

    getListInvoicev1(date: Date, clientNumber: number, personName: string, magna: boolean, premium: boolean, diesel: boolean, token: string): Observable<any> {

    
    let dateFormatted =  date.toISOString().substring(0,10);

    return this.http.get(this.urlInvoice  + 'api/XIGA/GetConsumptionPortalByClient?toDate=' + dateFormatted + "&clientNumber=" + clientNumber + "&personName=" + personName + "&magna=" + magna + "&premium=" + premium + "&diesel=" + diesel,{
      headers: {
        'Authorization': 'Bearer ' + token
      }
    });

  }

  loadDataFiscal(clientNumber:number):Observable<any>{
    return this.http.get(this.url + 'Invoicing/client/data/fiscal?clientNumber='+clientNumber);
  }

  updateZipCode(clientNumber:number,zipCode:number):Observable<any>{
    let data ={
      ClientNumber:clientNumber,
      ZipCode:zipCode,
    } 

    return this.http.post(this.url+"Invoicing/update/zipcode",data);
  }

  doListInvoice(date: Date, clientNumber: number, personName: string, magna: boolean, premium: boolean, diesel: boolean, token: string): Observable<any> {

    
    let dateFormatted =  date.toISOString().substring(0,10);

    return this.http.post(this.urlInvoice + 'XIGA/InvoicingConsumptionsPortal?toDate=' + dateFormatted + "&clientNumber=" + clientNumber + "&personName=" + personName + "&magna=" + magna + "&premium=" + premium + "&diesel=" + diesel,'', {
      headers: {
        'Authorization': 'Bearer ' + token
      }
    })

  }

  
  invoiceConsumptions(date: Date, clientNumber: number, personName: string, magna: boolean, premium: boolean, diesel: boolean, token: string): Observable<any> {

    
    let dateFormatted =  date.toISOString().substring(0,10);

    let data={
       fromDate:dateFormatted,
       clientNumber:clientNumber,
       personName:personName,
       regular:magna,
       supreme:premium,
       diesel:diesel,
    }

    return this.http.post(this.url + 'Invoicing/consumptions',data)

  }

}
